import { ApplicationConfig, InjectionToken, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig, withViewTransitions } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage } from 'ngx-webstorage';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HammerModule } from '@angular/platform-browser';
import { SnackBarModule } from '@polk_county_public_schools/ngx-pcps-dialogs/snackbar';
// import { AuthTokenInterceptor } from 'routes/interceptor';

export function getBaseUrl(): string {
    return document.getElementsByTagName('base')[0].href;
}

export const BASE_URL = new InjectionToken<string>('BASE_URL');

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(
            routes,
            withComponentInputBinding(),
            withRouterConfig({ paramsInheritanceStrategy: 'always' }),
            withViewTransitions()
        ),
        { provide: BASE_URL, useFactory: getBaseUrl, deps: [] },
        provideHttpClient(/* withInterceptors([AuthTokenInterceptor]) */),
        importProvidersFrom(HammerModule, SnackBarModule),
        provideNgxWebstorage(
            withNgxWebstorageConfig({ separator: ':', caseSensitive: true }),
            withLocalStorage(),
            withSessionStorage()
        ),
        provideAnimationsAsync(),
    ],
};
